import type { ApprovalChain } from '../approval-chain.model';

export const LEASE_CANCELLATION_CHAIN: ApprovalChain = {
  id: 'lease-cancellation',
  label: 'Lease Cancellation',
  applicationTypes: ['LEASE_CANCELLATION'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Approve', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_APPROVED' },
    { role: 'SURVEYOR_GENERAL_TECHNICIAN', action: 'Recommend', from: ['REGISTRAR_APPROVED'], to: 'SG_TECHNICIAN_RECOMMENDED' },
    { role: 'SURVEYOR_GENERAL', action: 'Approve', from: ['SG_TECHNICIAN_RECOMMENDED'], to: 'APPROVED' },
  ],
};
